<template>
  <div class="tabs_content">
    <section v-if="idSubscriber">
      <a
          v-if="$_updateActionAllowed"
          @click.stop.prevent="$router.push({name: 'subscriberNewDashboardCarousel', params: {idSubscriber: idSubscriber}})"
          class="tab_button tab_button_add"
          :title="$gettext('Přidat carousel')">
        Přidat carousel
      </a>
      <carousels-list
          :id-subscriber="idSubscriber" />
    </section>
  </div>
</template>

<script>
import CarouselsList from "./CarouselsList";

export default {
  name: "SubscriberDetailDashboard",
  components: { CarouselsList },
  props: {
    entity: Object
  },
  computed: {
    idSubscriber() {
      if (this.entity && 'id' in this.entity) {
        return this.entity.id;
      } else {
        return null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/dashboard/Dashboard.vue